import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'DELETE_WAREHOUSE_SCHEDULING_RESTRICTION_',
  }
);

export interface DeleteWarehouseSchedulingRestrictionState {
  id: number | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface DeleteWarehouseSchedulingRestrictionRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: DeleteWarehouseSchedulingRestrictionState = {
  id: null,
  loading: false,
  errorMessage: null,
};

const request = (
  state: DeleteWarehouseSchedulingRestrictionState,
  action: DeleteWarehouseSchedulingRestrictionRequestAction
) =>
  update(state, {
    id: { $set: action.id },
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: DeleteWarehouseSchedulingRestrictionState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const failure = (state: DeleteWarehouseSchedulingRestrictionState, action: FailureAction) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: DeleteWarehouseSchedulingRestrictionState) =>
  update(state, {
    id: { $set: null },
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const deleteWarehouseSchedulingRestriction = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const DeleteWarehouseSchedulingRestrictionTypes = Types;
export const DeleteWarehouseSchedulingRestrictionActions = Creators;
